function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "21.591%",
  y1: "5.401%",
  x2: "84.397%",
  y2: "94.599%",
  id: "weekly-live-demo_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3FFFC",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#48D59F",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "75.31%",
  y1: "19.383%",
  x2: "25.946%",
  y2: "79.51%",
  id: "weekly-live-demo_svg__d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4E8F2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CDD9",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "25.946%",
  y1: "32%",
  x2: "81.576%",
  y2: "78.533%",
  id: "weekly-live-demo_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4E8F2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CDD9",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "75.31%",
  y1: "47.101%",
  x2: "35.721%",
  y2: "77.721%",
  id: "weekly-live-demo_svg__f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4E8F2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CDD9",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  id: "weekly-live-demo_svg__a",
  d: "M0 39h48V0H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "weekly-live-demo_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#weekly-live-demo_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M36.4 14.619c0-2.966-2.417-5.369-5.4-5.369-2.982 0-5.4 2.403-5.4 5.369 0 2.077 1.2 3.86 2.937 4.751-3.771.852-6.537 3.607-6.537 6.88h18c0-3.273-2.765-6.028-6.537-6.88 1.737-.892 2.937-2.674 2.937-4.751z",
  fill: "url(#weekly-live-demo_svg__b)",
  mask: "url(#weekly-live-demo_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 30V2h44v28H2zm46 2V0H0v32h17v5H9v2h30v-2h-8v-5h17z",
  fill: "url(#weekly-live-demo_svg__d)",
  mask: "url(#weekly-live-demo_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 26h22V6H20v20zM6 26h12V6H6v20zm-2 2h40V4H4v24z",
  fill: "url(#weekly-live-demo_svg__e)",
  mask: "url(#weekly-live-demo_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#weekly-live-demo_svg__f)",
  mask: "url(#weekly-live-demo_svg__c)",
  d: "M8 11h8V9H8zm0 4h8v-2H8zm0 4h8v-2H8zm0 4h8v-2H8z"
}));

function SvgWeeklyLiveDemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDggMzkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCB4MT0iMjEuNTkxJSIgeTE9IjUuNDAxJSIgeDI9Ijg0LjM5NyUiIHkyPSI5NC41OTklIiBpZD0iYiI+PHN0b3Agc3RvcC1jb2xvcj0iI0UzRkZGQyIgb2Zmc2V0PSIwJSIvPjxzdG9wIHN0b3AtY29sb3I9IiM0OEQ1OUYiIG9mZnNldD0iMTAwJSIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IHgxPSI3NS4zMSUiIHkxPSIxOS4zODMlIiB4Mj0iMjUuOTQ2JSIgeTI9Ijc5LjUxJSIgaWQ9ImQiPjxzdG9wIHN0b3AtY29sb3I9IiNFNEU4RjIiIG9mZnNldD0iMCUiLz48c3RvcCBzdG9wLWNvbG9yPSIjQzlDREQ5IiBvZmZzZXQ9IjEwMCUiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCB4MT0iMjUuOTQ2JSIgeTE9IjMyJSIgeDI9IjgxLjU3NiUiIHkyPSI3OC41MzMlIiBpZD0iZSI+PHN0b3Agc3RvcC1jb2xvcj0iI0U0RThGMiIgb2Zmc2V0PSIwJSIvPjxzdG9wIHN0b3AtY29sb3I9IiNDOUNERDkiIG9mZnNldD0iMTAwJSIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IHgxPSI3NS4zMSUiIHkxPSI0Ny4xMDElIiB4Mj0iMzUuNzIxJSIgeTI9Ijc3LjcyMSUiIGlkPSJmIj48c3RvcCBzdG9wLWNvbG9yPSIjRTRFOEYyIiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iI0M5Q0REOSIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBpZD0iYSIgZD0iTTAgMzloNDhWMEgweiIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxtYXNrIGlkPSJjIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjxwYXRoIGQ9Ik0zNi40IDE0LjYxOWMwLTIuOTY2LTIuNDE3LTUuMzY5LTUuNC01LjM2OS0yLjk4MiAwLTUuNCAyLjQwMy01LjQgNS4zNjkgMCAyLjA3NyAxLjIgMy44NiAyLjkzNyA0Ljc1MS0zLjc3MS44NTItNi41MzcgMy42MDctNi41MzcgNi44OGgxOGMwLTMuMjczLTIuNzY1LTYuMDI4LTYuNTM3LTYuODggMS43MzctLjg5MiAyLjkzNy0yLjY3NCAyLjkzNy00Ljc1MXoiIGZpbGw9InVybCgjYikiIG1hc2s9InVybCgjYykiLz48cGF0aCBkPSJNMiAzMFYyaDQ0djI4SDJ6bTQ2IDJWMEgwdjMyaDE3djVIOXYyaDMwdi0yaC04di01aDE3eiIgZmlsbD0idXJsKCNkKSIgbWFzaz0idXJsKCNjKSIvPjxwYXRoIGQ9Ik0yMCAyNmgyMlY2SDIwdjIwek02IDI2aDEyVjZINnYyMHptLTIgMmg0MFY0SDR2MjR6IiBmaWxsPSJ1cmwoI2UpIiBtYXNrPSJ1cmwoI2MpIi8+PHBhdGggZmlsbD0idXJsKCNmKSIgbWFzaz0idXJsKCNjKSIgZD0iTTggMTFoOFY5SDh6TTggMTVoOHYtMkg4ek04IDE5aDh2LTJIOHpNOCAyM2g4di0ySDh6Ii8+PC9nPjwvc3ZnPgo=";
export { SvgWeeklyLiveDemo as ReactComponent };